export enum DialogType {
  TopLevelTrip,
  RequestTrip,
  ScheduleCall,
}
